import { render, staticRenderFns } from "./banksList.vue?vue&type=template&id=fe887582&scoped=true"
import script from "./banksList.vue?vue&type=script&lang=js"
export * from "./banksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe887582",
  null
  
)

export default component.exports